import type { ReactNode } from 'react';
import Footer from '@/src/components/ui/Footer';
import { main, wrapper } from './defaultLayout.styles';

type DefaultLayoutProps = {
  children: ReactNode;
  showFooterNearMeLinks?: boolean;
};

export function DefaultLayout({ children, showFooterNearMeLinks }: DefaultLayoutProps) {
  return (
    <div className={wrapper}>
      <main className={main}>{children}</main>
      <Footer showNearMeLinks={showFooterNearMeLinks} />
    </div>
  );
}
